__turbopack_context__.v({
  "cartBadgeCounter": "nav-cart-module__dbziPG__cartBadgeCounter",
  "knob": "nav-cart-module__dbziPG__knob",
  "navCartBtn": "nav-cart-module__dbziPG__navCartBtn",
});
